import { Map, OrderedMap } from 'immutable';

export const SIXTEEN_DAYS = 1382400;
export const TOTAL_RUNS = 'Total Test Runs';
export const DEFAULT_FILTER = Object.freeze({ owners: ['myself'] });
export const REQUEST_CANCEL_MESSAGE = 'REQUEST_CANCELED_BY_USER';
export const TEST_HISTORY_CANCEL_TOKEN_ID = 'TestHistoryContainer';
export const TEST_OVERVIEW_LAST_TEST_CASES_SIZE = 10;
export const ANALYTICS_API_INFO = 'https://wiki.saucelabs.com/display/DOCS/Analytics+Methods';
export const ANALYTICS_HELP_INFO = 'https://wiki.saucelabs.com/display/DOCS/Guide+to+the+Analytics+Interface';
export const ANALYTICS_TOUR_VIDEO = 'https://www.youtube.com/watch?v=Cmj_Qd2Hrgs';
export const COMMON_ERRORS_URL = 'https://wiki.saucelabs.com/display/DOCS/Common+Error+Messages';
export const TEST_STATUS_INFO_URL = Object.freeze({
  url: 'https://wiki.saucelabs.com/display/DOCS/Annotating+Tests+with+the+Sauce+Labs+REST+API',
  label: 'More Info On Status',
});

export const TESTS_REQUEST_SIZE = 10;
export const TESTS_BY_ERROR_LIMIT = 20;

export const STATUS_KEYS = ['passed', 'failed', 'errored', 'complete'];
export const TEST_KEYS = ['count'];
export const TEST_START_TIME_FORMAT = 'dd/MM/yyyy HH:mm:ss';
export const TESTS_CHART_SIZE = Object.freeze({
  height: 250,
  width: '100%',
});

export const CHARTS_PEAK_ACTIVE_COLOR = 'green';
export const CHARTS_PEAK_PAST_COLOR = 'greenGray';
export const CHARTS_TESTS_ACTIVE_COLOR = 'darkBlue';
export const CHARTS_TESTS_PAST_COLOR = 'darkBlueGray';

export const VM_CONCURRENCY_DATA_KEYS = [
  Object.freeze({ name: 'peak_vm_ccy1', color: CHARTS_PEAK_PAST_COLOR, legendPrefix: 'Previous' }),
  Object.freeze({ name: 'peak_vm_ccy2', color: CHARTS_PEAK_ACTIVE_COLOR, legendPrefix: 'Last' }),
];

export const TEST_CONCURRENCY_DATA_KEYS = [
  Object.freeze({ name: 'tests_by_day1', color: CHARTS_TESTS_PAST_COLOR, legendPrefix: 'Previous' }),
  Object.freeze({ name: 'tests_by_day2', color: CHARTS_TESTS_ACTIVE_COLOR, legendPrefix: 'Last' }),
];

export const STATUSES = Object.freeze({
  errored: Object.freeze({
    color: '#f68d38',
    value: 'errored',
  }),
  passed: Object.freeze({
    color: '#70be44',
    value: 'passed',
  }),
  complete: Object.freeze({
    color: '#ccc',
    value: 'complete',
  }),
  failed: Object.freeze({
    color: '#e2231a',
    value: 'failed',
  }),
  tests: Object.freeze({
    color: '#1395f0',
    value: 'tests',
  }),
  count: Object.freeze({
    color: '#1395f0',
    value: 'tests',
  }),
});

export const BUILD_STATUS = Object.freeze({
  failed: Object.freeze({
    value: 'failed',
    label: 'Failed tests only',
    trackEvent: 'BUILD_STATUS_FAILED_TEST_CHECKBOX',
  }),
  errored: Object.freeze({
    value: 'errored',
    label: 'Errored tests only',
    trackEvent: 'BUILD_STATUS_ERRORED_TEST_CHECKBOX',
  }),
});

export const TESTS_TABLE_COLUMNS = Object.freeze({
  name: Object.freeze({
    key: 'name',
    label: 'Name',
  }),
  startTime: Object.freeze({
    key: 'start_time',
    label: 'Start Time',
  }),
  duration: Object.freeze({
    key: 'duration',
    label: 'Duration',
  }),
  owner: Object.freeze({
    key: 'owner',
    label: 'Owner',
  }),
  status: Object.freeze({
    key: 'status',
    label: 'Status',
  }),
  error: Object.freeze({
    key: 'error',
    label: 'Error',
  }),
});

export const BUILDS_TABLE_COLUMNS = Object.freeze({
  name: Object.freeze({
    key: 'name',
    label: 'Name',
  }),
  startTime: Object.freeze({
    key: 'start_time',
    label: 'Start Time',
  }),
  duration: Object.freeze({
    key: 'duration',
    label: 'Duration',
  }),
  efficiency: Object.freeze({
    key: 'efficiency',
    label: 'Efficiency',
  }),
  owner: Object.freeze({
    key: 'owner',
    label: 'Owner',
  }),
  status: Object.freeze({
    key: 'status',
    label: 'Status',
  }),
});

export const OWNER_FILTER_KEYS = Object.freeze({
  OWNERS: 'owners',
  TEAM: 'owner_team',
  USER: 'owner_indv',
});

export const TEAM_API_DEFAULT_PARAMS = Object.freeze({
  limit: 1000,
  offset: 0,
});

export const OWNER_RADIO_OPTIONS = ['myself', 'organization', 'team'];

export const ACTIVITY_REQUEST_TYPES = Object.freeze({
  SCOPE_MYSELF: 'scope-myself',
  SCOPE_ORG_XTM: 'scope-organization-xtm-admin',
  SCOPE_ORG_USER: 'scope-organization-user',
  SCOPE_MYTEAM: 'scope-myteam',
  OWNERS_USER: 'owners-user',
  OWNERS_TEAM: 'owners-team',
});

export const OWNER_FILTER_SCOPES = Object.freeze({
  ORGANIZATION: 'organization',
  MYSELF: 'myself',
  TEAM: 'team',
});

export const META_SKIP_ERROR_PAGE = { skipErrorPage: true };

export const ROOTCAUSE_QUERY_STRINGS = Object.freeze({
  TEST_HASH: 'testHash',
  PATTERN_ID: 'pattern',
  USER: 'user',
  OWNERS: 'owners',
});

export const TESTS_PAGE_SIZES = [10, 20, 30, 50, 100];

export const TESTS_PAGE_FILTER_FAILING = 'failing';
export const TESTS_PAGE_FILTER_PASSING = 'passing';

export const TESTS_PAGE_STATUSES = Object.freeze({
  all: Object.freeze({
    key: 'all',
    title: 'All',
    path: '/analytics/test-overview/tests',
    status: null,
  }),
  failed: Object.freeze({
    key: 'failed',
    title: 'Consistently Failing',
    path: '/analytics/test-overview/tests/failed',
    status: 'failed',
  }),
  passed: Object.freeze({
    key: 'passed',
    title: 'Consistently Passing',
    path: '/analytics/test-overview/tests/passed',
    status: 'passed',
  }),
  errored: Object.freeze({
    key: 'errored',
    title: 'Consistently Error',
    path: '/analytics/test-overview/tests/errored',
    status: 'errored',
  }),
  complete: Object.freeze({
    key: 'complete',
    title: 'Missing Status',
    path: '/analytics/test-overview/tests/complete',
    status: 'complete',
  }),
  inconsistent: Object.freeze({
    key: 'inconsistent',
    title: 'Inconsistent Result',
    path: '/analytics/test-overview/tests/inconsistent',
    status: 'inconsistent',
  }),
});

export const TESTS_PAGE_TABLE_HEADERS = Object.freeze({
  total_runs: 'Test Count',
  avg_duration: 'Average Test Duration',
  pass_rate: 'Pass Rate',
});

export const TEST_PAGE_HEALTH_SNAPSHOT_LEGEND = Object.freeze({
  failing: Object.freeze({
    status: 'failing',
    link: TESTS_PAGE_STATUSES.failed.path,
  }),
  passing: Object.freeze({
    status: 'passing',
    link: TESTS_PAGE_STATUSES.passed.path,
  }),
  errored: Object.freeze({
    status: 'errored',
    link: TESTS_PAGE_STATUSES.errored.path,
  }),
  missingStatus: Object.freeze({
    status: 'missingStatus',
    link: TESTS_PAGE_STATUSES.complete.path,
  }),
});

export const TEST_CASE_HEALTH_TITLE = 'Test Case Health Snapshot';
export const TEST_CASE_HEALTH_DESCRIPTION = 'Test Cases are grouped by it\'s "unique" test name.';

export const DEFAULT_GET_OWNERS_OPTIONS = Object.freeze({
  getOrganizationUsers: true,
  getTeams: true,
});

export const OWNER_OPTIONS_FAILURE_ANALYSIS = Object.freeze({
  getOrganizationUsers: false,
  getTeams: false,
});

export const ACTIVITY_TIME_RANGES = OrderedMap({
  'Last 1 day': Map({ type: 'relative', value: 24 * 60 * 60 }),
  'Last 7 days': Map({ type: 'relative', value: 7 * 24 * 60 * 60 }),
  'Last 30 days': Map({ type: 'relative', value: 30 * 24 * 60 * 60 }),
});

export const RELATIVE_TIME_RANGES = OrderedMap({
  'Last 15 mins': Map({ type: 'relative', value: 15 * 60 }),
  'Last 1 hour': Map({ type: 'relative', value: 60 * 60 }),
  'Last 6 hours': Map({ type: 'relative', value: 6 * 60 * 60 }),
  'Last 12 hours': Map({ type: 'relative', value: 12 * 60 * 60 }),
}).merge(ACTIVITY_TIME_RANGES);

export const FAILURE_ANALYSIS_TIME_RANGES = RELATIVE_TIME_RANGES.delete('Last 15 mins');

export const INCLUDE_START_IN_ACTIVITY = true;

export const TrendsType = {
  BROWSER: 'browser',
  OS: 'os',
  DEVICE: 'device',
  FRAMEWORK: 'framework',
};
